// Copyright ©️ 2026 eVolve MEP, LLC

import { ActionIcon, Button } from '@mantine/core';

import { EvolveIcon } from 'assets/icons/EvolveIcon';
import { AgGridStyleTooltip } from 'components/Mantine/AgGridStyleTooltip';

type Props = {
  onClick: () => void;
  disabled?: boolean;
  /** Uses an `ActionIcon` instead of a `Button` when `true` */
  actionIcon?: boolean;
};

/** A button component used to manage custom properties. Should be paired with an {@link EditCustomPropertiesModal} */
export const ManageCustomPropertiesButton = ({ onClick, disabled, actionIcon }: Props) => (
  <AgGridStyleTooltip label="Manage custom properties" withArrow>
    {actionIcon ? (
      <ActionIcon variant="light" size="input-sm" onClick={onClick} disabled={disabled}>
        <EvolveIcon icon="Manage" size="sm" />
      </ActionIcon>
    ) : (
      <Button size="compact-sm" variant="light" onClick={onClick} disabled={disabled}>
        <EvolveIcon icon="Manage" size="sm" />
      </Button>
    )}
  </AgGridStyleTooltip>
);
